import { render, staticRenderFns } from "./SearchPerPage.vue?vue&type=template&id=41d87118&scoped=true&"
import script from "./SearchPerPage.vue?vue&type=script&lang=js&"
export * from "./SearchPerPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchPerPage.vue?vue&type=style&index=0&id=41d87118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d87118",
  null
  
)

export default component.exports